import { InvoiceDetailsProvider } from './contexts/InvoicesContext';
import InvoiceDetailsTitleArea from './components/InvoiceDetailsTitleArea';
import InvoiceDetailsFields from './components/InvoiceDetailsFeilds';
import { InvoiceDetailsPopups } from './components/InvoiceDetailsPopups';
import PageArea from '../../components/shared/PageArea';
import { Grid } from '@mui/material';

const InvoiceDetails = () => {
  return <InvoiceDetailsProvider>
    <PageArea>
      <Grid container
        spacing={5}>
        <InvoiceDetailsTitleArea />
        <InvoiceDetailsFields />
      </Grid>
    </PageArea>
    <InvoiceDetailsPopups />
  </InvoiceDetailsProvider>;
};

export default InvoiceDetails;